export enum CollaboratorPermission {
  View = 0,
  Edit
}
